// @flow

import styled from 'styled-components';
import type { Theme } from '../../../types';
import CheckboxComponent from '../../form/checkbox';

export const CheckboxContainer = styled<any, Theme>('div')`
  display: flex;
  padding: 0.2rem 0;
  justify-content: space-between;
`;

export const Checkbox = styled<typeof CheckboxComponent, Theme, _>(CheckboxComponent)`
  /* This is an IE11 hack to position the checkbox text correctly */
  align-items: flex-end;
  align-items: initial;
`;

export default null;
